import { Link } from 'react-router-dom';
import { DEFAULT_ROUTE } from '../utils/menuConfig.js';

export default function NotFound() {
  return (
    <div className="container py-5 text-center" data-testid="notfound-page">
      <i className="fa-solid fa-compass fa-3x text-info mb-3" />
      <h1 className="display-5 font-weight-bold text-dark">404 — Page not found</h1>
      <p className="text-muted mb-4">The page you requested doesn't exist.</p>
      <Link to={DEFAULT_ROUTE} className="btn btn-primary">
        <i className="fa-solid fa-arrow-left mr-2" />Back to dashboard
      </Link>
    </div>
  );
}
